var map = {
	"./en/about.json": [
		79732,
		732
	],
	"./en/appointment.json": [
		40668,
		668
	],
	"./en/auth.json": [
		15021,
		21
	],
	"./en/common.json": [
		79802,
		802
	],
	"./en/cookie.json": [
		90269,
		269
	],
	"./en/doctor.json": [
		47652,
		652
	],
	"./en/eeszt.json": [
		89888,
		888
	],
	"./en/footer.json": [
		38172,
		172
	],
	"./en/help.json": [
		61988,
		988
	],
	"./en/home.json": [
		34820,
		820
	],
	"./en/institution.json": [
		62155,
		155
	],
	"./en/menu.json": [
		32048,
		48
	],
	"./en/messages.json": [
		49903,
		903
	],
	"./en/notification.json": [
		27016,
		16
	],
	"./en/patients.json": [
		58949,
		949
	],
	"./en/professions.json": [
		1582,
		582
	],
	"./en/profile.json": [
		11432,
		432
	],
	"./en/protocol.json": [
		42035,
		35
	],
	"./en/settings.json": [
		42974,
		974
	],
	"./en/statistics.json": [
		47836,
		836
	],
	"./en/survey.json": [
		64777,
		777
	],
	"./en/table.json": [
		53477,
		477
	],
	"./en/translation.json": [
		44362,
		362
	],
	"./en/treatment.json": [
		30621,
		621
	],
	"./hu/about.json": [
		59216,
		216
	],
	"./hu/appointment.json": [
		136,
		136
	],
	"./hu/auth.json": [
		74553,
		553
	],
	"./hu/common.json": [
		20126,
		126
	],
	"./hu/cookie.json": [
		369,
		369
	],
	"./hu/doctor.json": [
		50080,
		80
	],
	"./hu/eeszt.json": [
		68876,
		876
	],
	"./hu/footer.json": [
		1440,
		440
	],
	"./hu/help.json": [
		5008,
		8
	],
	"./hu/home.json": [
		67672,
		672
	],
	"./hu/institution.json": [
		78743,
		743
	],
	"./hu/menu.json": [
		87228,
		228
	],
	"./hu/messages.json": [
		11179,
		179
	],
	"./hu/notification.json": [
		26956,
		956
	],
	"./hu/patients.json": [
		53601,
		601
	],
	"./hu/professions.json": [
		46538,
		538
	],
	"./hu/profile.json": [
		18332,
		332
	],
	"./hu/protocol.json": [
		20135,
		135
	],
	"./hu/settings.json": [
		69634,
		634
	],
	"./hu/statistics.json": [
		81152,
		152
	],
	"./hu/survey.json": [
		44141,
		141
	],
	"./hu/table.json": [
		20945,
		945
	],
	"./hu/translation.json": [
		74446,
		446
	],
	"./hu/treatment.json": [
		70025,
		25
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 39147;
module.exports = webpackAsyncContext;